// ANCHOR Base
import { Checkbox } from 'baseui/checkbox';
import { Block } from 'baseui/block';

// ANCHOR Models
import { useFormQuestionAnswersForStudentData } from '@lyon/scoped-models/form/FormQuestionAnswersDataForStudent';
import {
  useFormSubmissionQuestionItemAnswer,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormQuestionStatusIcon } from '../../LyonViewAnswerFormQuestionStatusIcon';

// ANCHOR Styles
import { BLOCK, CHECKBOX } from './styles';

export const LyonViewAnswerFormCheckbox = constant(() => {
  const choices = useFormQuestionAnswersForStudentData();
  const userAnswers = useFormSubmissionQuestionItemAnswer();

  if (!choices) {
    return <Loader />;
  }

  if (choices.length === 0) {
    return null;
  }

  return (
    <>
      <Block overrides={BLOCK}>
        {
        choices.map(({ name }) => (
          <Checkbox
            checked={userAnswers.includes(name)}
            labelPlacement="right"
            overrides={CHECKBOX}
          >
            {name}
            {userAnswers.includes(name) && <LyonViewAnswerFormQuestionStatusIcon />}
          </Checkbox>
        ))
      }
      </Block>
    </>
  );
});
